import { createStyles, makeStyles } from '@material-ui/core'

export default makeStyles((theme) =>
  createStyles({
    milkBagHeroContentContainer: {
      paddingTop: theme.spacing(6),
      paddingBottom: theme.spacing(8),
      backgroundColor: theme.palette.background.contrast,
    },
    milkBagHeroContent: {
      textAlign: 'left',
    },
    milkBagHeroContentH4: {
      marginBottom: 8,
    },
    nowrap: {
      [theme.breakpoints.down('xs')]: {
        textWrap: 'nowrap',
      },
    },
    milkBagHeroContentList: {
      paddingInlineStart: 0,
      '& li': {
        paddingLeft: 24,
        listStyle: 'none',
      },
      paddingBottom: theme.spacing(2),
    },
    listItemArcBullet: {
      background:
        'url(//images.babylist.com/image/upload/v1694200328/DME/arc-bullet.svg) no-repeat left 4px',
    },
    listItemTriangleBullet: {
      background:
        'url(//images.babylist.com/image/upload/v1694200329/DME/triangle-bullet.svg) no-repeat left 4px',
    },
    listItemCircleBullet: {
      background:
        'url(//images.babylist.com/image/upload/v1694200328/DME/circle-bullet.svg) no-repeat left 4px',
    },
    alignCenterOnMobile: {
      [theme.breakpoints.down('xs')]: {
        textAlign: 'center',
      },
    },
  })
)
